import { RefundStatusEnum, ReleaseStatusEnum } from 'common/constants/enum';
import { PillStatus } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

interface Props {
  value: string;
  style?: StyleObject | any;
}

export default function RefundPillStatus(props: Props) {
  const { t } = useTranslation();
  const { value, style } = props;
  let status: 'blue' | 'brown' | 'green' | 'red' | 'yellow' | 'other';
  let text: string = '';

  switch (value) {
    case RefundStatusEnum.Processed:
    case ReleaseStatusEnum.Requested: //release
      status = 'green';
      if (value === RefundStatusEnum.Processed) text = t('status:processed');
      else if (value === ReleaseStatusEnum.Requested)
        text = t('status:requested');
      break;
    case RefundStatusEnum.PendingApproval:
    case RefundStatusEnum.DraftCancel:
    case RefundStatusEnum.Draft:
    case ReleaseStatusEnum.PendingReleaseApproval:
      if (
        value === RefundStatusEnum.PendingApproval ||
        value === ReleaseStatusEnum.PendingReleaseApproval
      )
        text = t('status:waiting_approval');
      if (value === RefundStatusEnum.DraftCancel)
        text = t('status:cancel_pending');
      if (value === RefundStatusEnum.Draft) text = t('status:draft');
      status = 'yellow';
      break;
    case RefundStatusEnum.RejectedApproval:
    case ReleaseStatusEnum.RejectedReleaseApproval:
    case ReleaseStatusEnum.RejectRefund:
      text = t('status:rejected');
      status = 'red';
      break;
    case RefundStatusEnum.PendingCancel:
      status = 'brown';
      text = t('status:pending_cancel');
      break;
    case RefundStatusEnum.Completed:
    default:
      text = '-';
      if (value === RefundStatusEnum.Completed) text = t('status:completed');
      else if (value === RefundStatusEnum.Cancel) text = t('status:cancel');
      else if (value === RefundStatusEnum.Waiting) text = t('status:waiting');

      status = 'other';
      break;
  }
  return <PillStatus $style={style} status={status} children={text} />;
}
